import { ChangeEvent, useEffect, useState } from "react";

import { useI18n } from "@/contexts/i18nContext";
import HelperText from "@components/Field/HelperText";

import Typography from "../../../Typography";

import styles from "./Slider.module.css";

interface SliderProps extends React.HTMLProps<HTMLInputElement> {
  min?: number;
  max?: number;
  step?: number;
  type?: "linear" | "logarithmic";
  errorMessage?: string;
}

const Slider: React.FunctionComponent<SliderProps> = ({
  min = 0,
  max = 100,
  step = 1,
  value: passedValue,
  errorMessage,
  onChange,
  ...rest
}) => {
  const { abbreviateNumber } = useI18n();
  const [value, setValue] = useState<number>(Number(passedValue));
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const v = Number(e.target.value);
    setValue(Number(v));

    onChange && onChange(e);
  };
  useEffect(() => {
    setValue(Number(passedValue));
  }, [passedValue]);

  return (
    <div className={styles.root}>
      <input
        {...rest}
        className={styles.input}
        type="range"
        min={min}
        max={max}
        step={step}
        onChange={handleChange}
        value={value ?? min}
      />
      <Typography
        align="center"
        variant="caption"
        className={styles.faux}
        margin="none"
        style={{
          left: `calc(${(value / max) * 100}% - ${(value / max) * 50}px)`,
          transform: `translateY(-50%)`,
        }}
      >
        {abbreviateNumber(value)}
      </Typography>
      {errorMessage && <HelperText error content={errorMessage} />}
    </div>
  );
};

export default Slider;
